import React from 'react';

/**
 * The one step indicator for the /create/* wizard (replaces the shell's old
 * rightLabel pill and the copy-pasted inline "Step N of 3" pills). Canonical
 * classes are the tokenized pill that used to live inline on the
 * create-organization page.
 */
export default function WizardStepPill({
  step,
  total = 4,
  className = 'mb-4',
}: {
  // 4 steps (owner 2026-10-22): type → organization → divisions (or the
  // landing carry-through's "Confirm your structure", INT-0011 tier 2) →
  // who's playing. INT-0050 removed the design step.
  step: 1 | 2 | 3 | 4;
  total?: number;
  // Margin lives here (default keeps the hero spacing) so flex-row hosts
  // like the design step's sticky action bar can zero it for centering.
  className?: string;
}) {
  return (
    <div className={`${className} inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-gradient-to-r from-primary/10 to-primary-deep/10 px-4 py-1.5 text-sm font-medium text-primary ring-1 ring-primary/20`}>
      <div className="h-1.5 w-1.5 rounded-full bg-primary" />
      Step {step} of {total}
    </div>
  );
}
